// extracted by mini-css-extract-plugin
export default {"titleContainer":"style_titleContainer__5TTpZ","innerContainer":"style_innerContainer__uFSYO","verticalDivider":"style_verticalDivider__zNavq","title":"style_title__7kxxU"};